import React from 'react';
import PropTypes from 'prop-types';
import {
    Typography, List, ListItem, ListItemText,
} from '@material-ui/core';
import NumberUtils from 'lib/NumberUtils';
import Loading from 'components/widgets/Loading';

const VehiclesInCards = ({
    classes,
    records,
    onSelect,
    inHouse,
    loading,
}) => {
    if (loading) return (<Loading className="loading-table" />);

    const {
        list, listItem, text, flex, textBold,
    } = classes;

    return (
        <List
            className={list}
        >
            {records.map((record, index) => {
                const {
                    stockNumber,
                    year,
                    make,
                    model,
                    trim,
                    engine,
                    vin,
                    lotName,
                    maximumReconCost,
                    totalRepairs,
                } = record;

                const primaryText = (
                    <>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Stock Number: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {stockNumber}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Year: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {year}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Make: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {make}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Model: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {model}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Trim: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {trim}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Engine: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {engine}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                VIN: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {vin}
                            </Typography>
                        </span>
                        <span className={flex}>
                            <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                Lot: &nbsp;
                            </Typography>
                            <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                {lotName}
                            </Typography>
                        </span>
                        {inHouse && (
                            <>
                                <span className={flex}>
                                    <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                        Maximun Recon Cost: &nbsp;
                                    </Typography>
                                    <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                        {NumberUtils.applyCurrencyFormat(maximumReconCost)}
                                    </Typography>
                                </span>
                                <span className={flex}>
                                    <Typography component="span" className={textBold} color="textPrimary" align="left" display="inline">
                                        Total Repairs: &nbsp;
                                    </Typography>
                                    <Typography component="span" className={text} color="textSecondary" align="left" display="inline">
                                        {NumberUtils.applyCurrencyFormat(totalRepairs)}
                                    </Typography>
                                </span>
                            </>
                        )}
                    </>
                );

                return (
                    <React.Fragment key={index}>
                        <ListItem
                            className={listItem}
                            button
                            onClick={() => {
                                onSelect(record);
                            }}
                        >
                            <ListItemText primary={primaryText} />
                        </ListItem>
                    </React.Fragment>
                );
            })}
        </List>
    );
};

VehiclesInCards.propTypes = {
    classes: PropTypes.object.isRequired,
    records: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    inHouse: PropTypes.bool,
    loading: PropTypes.bool,
};

VehiclesInCards.defaultProps = {
    records: [],
    inHouse: false,
    loading: false,
};

export default VehiclesInCards;
